import { useEffect, useState } from "react";
import { aboutTextApi } from "../api/aboutTextApi";

export default function AboutTextEdit() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const [form, setForm] = useState({
    textAz: "",
    textEn: "",
    textRu: "",
    missionAz: "",
    missionEn: "",
    missionRu: "",
  });

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await aboutTextApi.get();
      const x = res.data || {};
      setForm({
        textAz: x.textAz || "",
        textEn: x.textEn || "",
        textRu: x.textRu || "",
        missionAz: x.missionAz || "",
        missionEn: x.missionEn || "",
        missionRu: x.missionRu || "",
      });
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const set = (name) => (e) => setForm((p) => ({ ...p, [name]: e.target.value }));

  const save = async () => {
    setSaving(true);
    setErr("");
    try {
      await aboutTextApi.update(form);
      await load();
      alert("Saved!");
    } catch (e) {
      setErr(e?.response?.data || e.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="card"><div className="cardBody">Yüklənir...</div></div>;

  return (
    <div>
      <h1 className="pageTitle">Şirkət haqqında</h1>

      {err ? (
        <div className="card">
          <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>{String(err)}</div>
        </div>
      ) : null}

      <div className="card" style={{ marginTop: 12 }}>
        <div className="cardBody">

          <label>AZ</label>
          <textarea className="input" rows={8} value={form.textAz} onChange={set("textAz")} />

          <label style={{ marginTop: 10 }}>EN</label>
          <textarea className="input" rows={8} value={form.textEn} onChange={set("textEn")} />

          <label style={{ marginTop: 10 }}>RU</label>
          <textarea className="input" rows={8} value={form.textRu} onChange={set("textRu")} />

          <hr style={{ margin: "16px 0" }} />

          <h3>Missiya</h3>

          <label>AZ</label>
          <textarea className="input" rows={3} value={form.missionAz} onChange={set("missionAz")} />

          <label style={{ marginTop: 10 }}>EN</label>
          <textarea className="input" rows={3} value={form.missionEn} onChange={set("missionEn")} />

          <label style={{ marginTop: 10 }}>RU</label>
          <textarea className="input" rows={3} value={form.missionRu} onChange={set("missionRu")} />

          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button className="btn btnPrimary" disabled={saving} onClick={save}>
              {saving ? "Saving..." : "Yadda saxla"}
            </button>
            <button className="btn" disabled={saving} onClick={load}>
              Yenilə
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
